import messages from '../../constants/logMessages.json';
import tracking from '../../tracking/tracking';
import { AnalyticsConst } from '../../types';
import { inputFieldPayload, OnShowPayload } from '../../types/designSystem';
import { jsonToString } from '../analyticsUtils';
import { checkForPII } from '../helpers';
import logging, { getMessage } from '../logging';

const { errorHeading, errorBold } = messages;

export const onShowHandler = ({
  data,
  trackProps,
  componentType,
  action,
}: OnShowPayload) => {
  try {
    const { severity, variant, version } = trackProps;
    let { label } = trackProps;

    // PII suppress.
    if (label) label = checkForPII(label) as string;

    const trackObject = {
      event: `et_${action}_${severity}`,
      eventAction: label ? label.toLowerCase() : AnalyticsConst.NOT_SET,
      eventLabel: label || AnalyticsConst.NOT_SET,
      trackProps: {
        ...trackProps,
        adsComponent: `${version}|${componentType}|${variant}`,
        action: `${action}: ${severity}`,
      },
      data,
    };

    tracking.analyticsEngagementTracking(trackObject);
  } catch (e) {
    logging.error(
      getMessage('catchError', ['onShowHandler', jsonToString([e as object])]),
      errorHeading,
      errorBold
    );
  }
};

/**
 * Date Picker Specific On Show Handler
 */
export const datePickerOnShowHandler = ({
  data,
  trackProps,
  componentType,
  action,
}: inputFieldPayload) => {
  try {
    const { variant, version, fieldName = '', behaviour = '' } = trackProps;
    let { label } = trackProps;

    // PII suppress.
    if (label) label = checkForPII(label) as string;

    const trackObject = {
      event: `et_${action}`,
      eventAction: `${fieldName}: ${behaviour}`,
      eventLabel: label || AnalyticsConst.NOT_SET,
      trackProps: {
        ...trackProps,
        adsComponent: `${version}|${componentType}|${variant}`,
      },
      data,
    };

    tracking.analyticsEngagementTracking(trackObject);
  } catch (e) {
    logging.error(
      getMessage('catchError', [
        'datePickerOnShowHandler',
        jsonToString([e as object]),
      ]),
      errorHeading,
      errorBold
    );
  }
};
